import { Box, ImageList, ImageListItem, useMediaQuery, useTheme } from "@mui/material";
import { useState, useCallback } from "react";
import ImageViewer from 'react-simple-image-viewer';

const DigitalStudioImageGallery = ({list}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = useCallback((index) => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    }, []);

    return (
        <>
            <Box 
                className="hideScrollBar"
                sx={{ 
                    width: '100%', 
                    maxHeight: isMobile ? 500 : 1000, 
                    overflowY: 'scroll' 
                }}
            >
                <ImageList 
                    variant="masonry" 
                    cols={isMobile ? 2 : 3} 
                    gap={8}
                >
                    {
                        list.map((item, index) => (
                            <ImageListItem 
                                key={index}
                                sx={{
                                    cursor: 'pointer',
                                    '&: hover': {
                                        transform: 'scale(0.95)'
                                    }
                                }}
                            >
                                <img
                                    srcSet={`${item}?fit=crop&auto=format&dpr=2 2x`}
                                    src={`${item}?fit=crop&auto=format`}
                                    alt={index}
                                    loading="lazy"
                                    style={{
                                        borderRadius: '16px'
                                    }}
                                    onClick={ () => openImageViewer(index) }
                                />
                            </ImageListItem>
                        ))
                    }
                </ImageList>
            </Box>

            {
                isViewerOpen && (
                    <ImageViewer
                        src={ list }
                        currentIndex={ currentImage }
                        disableScroll={ true }
                        closeOnClickOutside={ true }
                        onClose={ closeImageViewer }
                        backgroundStyle={{
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            zIndex: 9999
                        }}
                    />
                )
            }
        </>
    );
}

export default DigitalStudioImageGallery;